function getIdmrBaseUrl(): string {
    const loc = window.location.href;

    // Production or staging
    if (loc.includes("maintener.icelandair.is") || loc.includes("maintener-frontend.stage")) {
        return process.env.REACT_APP_IDMR_LINK || "";
    }
    // Development/localhost - default to UAT
    return process.env.REACT_APP_IDMR_LINK_UAT || "";
}

export function redirectToIdmrTask(woBarcode: string, taskBarcode: string): boolean {
    const baseUrl = getIdmrBaseUrl();
    window.open(`${baseUrl}${woBarcode}_${taskBarcode}&extId=${woBarcode}_${taskBarcode}`, '_blank');
    return true;
}

export function redirectToIdmrWorkPackage(woBarcode: string): boolean {
    const baseUrl = getIdmrBaseUrl();
    window.open(`${baseUrl}${woBarcode}&extId=${woBarcode}`, '_blank');
    return true;
}